








import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { IaElementsInterface } from '@/types/contentContract';

@Component({
  name: 'Default'
})
export default class Default extends Vue {
  @Prop({ type: Object, default: () => [] })
  template!: IaElementsInterface;

  get questions(): object {
    return this.template.data.questions;
  }
}
